export enum TuitionPlanFrequency {
    Once = 'once',
    Annual = 'annual',
    Monthly = 'monthly',
    MonthlyExtended = 'monthly_extended',
    MonthlyAccelerated3 = 'monthly_accelerated_3',
    MonthlyAccelerated4 = 'monthly_accelerated_4',
    MonthlyAccelerated5 = 'monthly_accelerated_5',
    FullScholarship = 'full_scholarship',
    Custom = 'custom', // deprecated
    BiAnnual = 'bi_annual', // deprecated
}

export enum TuitionPlanFrequencySortKey {
    full_scholarship = 0,
    once = 1,
    annual = 2,
    monthly_accelerated_3 = 3,
    monthly_accelerated_4 = 4,
    monthly_accelerated_5 = 5,
    monthly = 6,
    monthly_extended = 7,
    custom = Number.MAX_VALUE, // deprecated
    bi_annual = Number.MAX_VALUE, // deprecated
}

export interface Institution {
    id: string;
    name: string;
}

export type TuitionPlan = {
    id: string;
    baseTuition: number;
    name: string;
    tag: string;
    frequency: TuitionPlanFrequency;
    numIntervals: number | null;
};
